import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs} from "swiper/modules";
import {Fancybox} from "@fancyapps/ui";
import '@fancyapps/ui/src/Fancybox/Fancybox.scss';
import {Collapse, initTWE, Modal, Tab,} from "tw-elements";

initTWE({Modal, Tab});

Swiper.use([Navigation, Pagination, Thumbs]);

const thumbnailSwiper = new Swiper('.thumbnailSwiper', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});

const swiper = new Swiper('.product-images-swiper', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    thumbs: {
        swiper: thumbnailSwiper,
    },
});

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('vorm') && urlParams.get('vorm') !== '') {
    const plexiDesignerSlide = document.querySelector('.swiper-slide:has(div#plexi-designer-ts)');

    if (plexiDesignerSlide) {
        const index = Array.from(plexiDesignerSlide.parentNode.children).indexOf(plexiDesignerSlide);
        swiper.slideTo(index);
    }
}

new Swiper('.upSellSwiper', {
    spaceBetween: 20,
    slidesPerView: 1.25,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

Fancybox.bind('.product-images .swiper-slide img, .product-images .swiper-slide [data-fancybox-element]', {
    groupAll: true
});

jQuery('.product-thumbs [data-thumb] a').click(function (e) {
    e.preventDefault();

    swiper.slideTo(jQuery(this).closest('[data-thumb]').index());
})

jQuery('.variations_form.cart').on('found_variation', function (e, variation) {
    const productCalculator = jQuery('[data-product-calculator]');

    productCalculator.data('priceExcl', variation.price_excl);
    productCalculator.data('priceIncl', variation.display_price);
})

jQuery('[data-image-zoom]').click(function (e) {
    e.preventDefault()

    jQuery(this)
        .parent()
        .find('.swiper-slide.swiper-slide-active img, .swiper-slide.swiper-slide-active [data-fancybox-element]')
        .click();
})

// The dropdown arrow icon on .styled-select is drawn with an absolutely
// positioned pseudo-element sitting above the <select>, so clicks on it (or
// anywhere else in the styled row) don't reach the <select> itself. Forward
// those clicks to open the native dropdown.
jQuery(document).on('click', '.product-option-row .styled-select', function (e) {
    const select = this.querySelector('select');

    if (!select || select === e.target || select.contains(e.target)) {
        return;
    }

    select.focus();

    if (typeof select.showPicker === 'function') {
        try {
            select.showPicker();
            return;
        } catch (err) {
            // Fall through to select.click() below.
        }
    }

    select.click();
})

jQuery(document).ready(function ($) {
    // Copy from product-price.js we need to make this public
    function removeErrorMessages(element = null) {
        if (element) {
            element.find('.invalid-message').remove();
        } else {
            $('.invalid-message').remove();
        }
    }

    function updateURLWithSelectedOptions() {
        $('.product-option-check').on('change', function () {
            var currentURL = new URL(window.location.href);

            $('.product-option-check:checked').each(function () {
                var optionName = $(this).attr('name');
                var selectedValue = $(this).val();
                currentURL.searchParams.set(optionName, selectedValue);
            });

            history.replaceState(history.state, '', currentURL);
        });
    }

    function updateProductOptionButtonsFromURL() {
        var optionName = $(this).attr('name');
        var selectedValue = $(this).val();
        $('.iconic-wlv-terms__term-content').each(function () {
            var href = $(this).attr('href');
            if (href) {
                var newURL = new URL(href, window.location.origin);
                newURL.searchParams.set(optionName, selectedValue);
                $(this).attr('href', newURL.toString());
            }
        });
    }

    updateURLWithSelectedOptions();
    updateProductOptionButtonsFromURL();

    function updateURLWithInputValues(input) {
        const queryName = input.dataset.queryName;
        const value = input.value;

        const currentURL = new URL(window.location.href);
        if (value !== '') {
            currentURL.searchParams.set(queryName, value);
        } else {
            currentURL.searchParams.delete(queryName);
        }
        history.replaceState(history.state, '', currentURL);
    }

    function updateLinksWithInputValues(input) {
        if (input.value === '') {
            return;
        }

        const queryName = input.dataset.queryName;
        const value = input.value;

        updateLinksUrl(queryName, value);
    }

    function updateLinksUrl(queryName, value) {
        const productOptionsRow = document.getElementsByClassName('product-options-row')[0];
        if (!productOptionsRow) {
            return;
        }

        productOptionsRow.querySelectorAll('a').forEach(function (link) {
            const href = link.getAttribute('href');
            if (!href) {
                return;
            }

            const newURL = new URL(href, window.location.origin);
            if (value !== '') {
                newURL.searchParams.set(queryName, value);
            } else {
                newURL.searchParams.delete(queryName);
            }
            link.setAttribute('href', newURL.toString());
        });
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('vorm') && urlParams.get('vorm') !== '') {
        updateLinksUrl('vorm', urlParams.get('vorm'));
    }

    document.querySelectorAll('[data-product-calculator] input[data-query-name]').forEach(function (input) {
        input.addEventListener('input', function () {
            updateURLWithInputValues(input);
            updateLinksWithInputValues(input);
        });

        updateLinksWithInputValues(input);
    });

    function updateProductOptionValue() {
        $('.form-row[data-option-type]').each(function () {
            const type = $(this).data('option-type');
            const productOptionsRow = $(this).closest('.product-options-row');
            const currentValueHolder = productOptionsRow.find('[data-current-value]');
            let currentValue = '';
            let finished = false;

            switch (type) {
                case 'radio':
                    const activeElement = $(this).find('input[type="radio"]:checked');

                    if (activeElement.length) {
                        currentValue = activeElement.data('checked-value');
                        finished = true;
                    }
                    break;
                case 'measurement':
                    const activeTextElement = $(this).find('input[type="measurement"]');

                    if (activeTextElement.length) {
                        currentValue = activeTextElement.data('checked-value');
                        finished = true;
                    }
                    break;
                case 'variation-select':
                    const activeSelectElement = $(this).find('select option:selected');

                    if (activeSelectElement.length && activeSelectElement.val() !== '') {
                        currentValue = activeSelectElement.val();
                        finished = true;
                    }
                    break;
            }

            if (currentValue.length > 0) {
                currentValue = '(' + currentValue + ')';
            }

            currentValueHolder.html(currentValue);
            productOptionsRow.find('[data-option-finished]').attr('data-option-finished', finished);
            productOptionsRow.find('.circle-option').toggleClass('circle-option-check', finished);
        });
    }

    function checkAndSetDimensions() {
        const row = $('[data-dimension-fields]');
        const productOptionsRow = row.closest('.product-options-row');
        const currentValueHolder = productOptionsRow.find('[data-current-value]');
        const lengthElement = row.find('[data-product-length]:visible');
        const widthElement = row.find('[data-product-width]:visible');

        let currentValue = '';

        if (lengthElement.val() && widthElement.val()) {
            const length = convertUnitValue(
                lengthElement.val(),
                lengthElement.data('inputUnit'),
                'mm',
            );

            const width = convertUnitValue(
                widthElement.val(),
                widthElement.data('inputUnit'),
                'mm',
            );

            currentValue = ' (' + length + 'mm x ' + width + 'mm)';
        }

        let finished = true;
        const dimensionFields = row.find('[data-dimension-field]:visible');
        dimensionFields.each(function () {
            if (!finished) {
                return;
            }
            if (!$(this).data('isValid')) {
                finished = false;
            }
        });

        if (lengthElement.length > 0 && widthElement.length > 0) {
            currentValueHolder.html(currentValue);
        }
        productOptionsRow.find('[data-option-finished]').attr('data-option-finished', finished);
        productOptionsRow.find('.circle-option').toggleClass('circle-option-check', finished);
    }

    checkAndSetDimensions();
    updateProductOptionValue();

    $(document)
        .on('plexi-designer:select-shape', function () {
            checkAndSetDimensions();
        })
        .on('change keyup', '[data-product-calculator] [data-dimension-field]', function () {
            checkAndSetDimensions();
        })
        .on('change', '[data-product-calculator] [data-option-type] input, [data-product-calculator] [data-option-type] select', function () {
            updateProductOptionValue();
        })
        .on('change', '[data-option-type="productSell"] input[type=number]', function (e) {
            const holder = $(this).closest('.quantity');

            holder.find('[data-upsize-quantity="min"]').prop('disabled', $(this).val() < 1);

            $(this).closest('[data-option-type="productSell"]').toggleClass('selected', $(this).val() > 0);
        })
        .on('click', '[data-upsize-quantity]', function (e) {
            e.preventDefault();

            const referencedQuantityField = $(this).closest('.quantity').find('input[type=number]');
            let quantity = parseInt(referencedQuantityField.val(), 10)

            if ($(this).data('upsize-quantity') === 'plus') {
                quantity += 1;
            } else {
                quantity -= 1;
            }

            if (quantity < 0) {
                quantity = 0;
            }

            referencedQuantityField.val(quantity).change();
        })
        .on('click', '[data-reset-product-options]', function (e) {
            e.preventDefault();

            let productCalculator = $(this).closest('[data-product-calculator]');
            if (!productCalculator.length) {
                productCalculator = $('[data-product-calculator]');
            }
            const quantityField = productCalculator.find('[data-totals] .qty');

            productCalculator.find('[data-option-type]').each(function () {
                const type = $(this).data('option-type');

                switch (type) {
                    case 'radio':
                        $(this).find('input[type="radio"]').each(function () {
                            $(this).prop('checked', $(this).data('default-value'));
                        })
                        break;
                    default:
                        $(this).val('');
                        break;
                }
            });

            productCalculator.find('[data-dimension-fields]').each(function () {
                $(this).find('[data-dimension-field]').each(function () {
                    if (this.type === 'checkbox') {
                        this.checked = false;
                    } else if (this.tagName === 'SELECT') {
                        this.selectedIndex = 0;
                    } else {
                        $(this).val('');
                    }
                });
            });

            productCalculator.find('input[data-query-name]').each(function () {
                const input = this;
                const isCheckboxOrRadio = input.type === 'checkbox' || input.type === 'radio';

                if (isCheckboxOrRadio) {
                    input.checked = input.dataset.defaultValue === 'true';
                } else {
                    input.value = '';
                }

                if (isCheckboxOrRadio && !input.checked) {
                    return;
                }

                updateURLWithInputValues(input);
                updateLinksWithInputValues(input);
            })

            checkAndSetDimensions();
            updateProductOptionValue();

            // Reset quantity to min value
            quantityField.val(quantityField.attr('min')).change();

            // Since this is a reset we do not need validation messages
            removeErrorMessages(productCalculator);

            // Show first toggle again
            const collapseElement = $($('[data-twe-target][data-option-finished="false"]:first').data('twe-target'));

            if (typeof collapseElement.attr('data-twe-collapse-show') === 'undefined') {
                const collapse = new Collapse(collapseElement.get(0));

                collapse.show();
            }

            if (window.plexi_designer) {
                window.plexi_designer.reset();
            }
        });

    const extraContentModalElement = document.getElementById("extraContentModal");
    if (extraContentModalElement) {
        extraContentModalElement.addEventListener("show.twe.modal", (e) => {
            const triggerButton = e.relatedTarget;
            const extraContent = triggerButton.getAttribute('data-extra-content');
            const modalBody = extraContentModalElement.querySelector("[data-twe-modal-body-ref]");
            modalBody.innerHTML = extraContent;
        });
    }

    $(document).on("click", ".plexi-shape", function (event) {
        event.preventDefault();

        $(".plexi-shape").removeClass("active");
        $(this).addClass("active");

        slideToPlexiDesigner();

        fillShapeTitle();
    });

    $(document).on("click input", "[data-dimension-field], .drill-holes-container button, .drill-holes-container input", slideToPlexiDesigner);

    function slideToPlexiDesigner() {
        const slideIndex = $(".paper-thumbnail").index();
        swiper.slideTo(slideIndex);
    }

    function fillShapeTitle() {
        const activeShape = document.querySelector('.plexi-shape.active');
        if (!activeShape) {
            return;
        }

        const dataTitle = activeShape.getAttribute('data-title');

        const dataTitleDisplay = document.getElementById('data-title-display');
        if (dataTitleDisplay) {
            dataTitleDisplay.textContent = '(' + dataTitle + ')';
        }
    }

    fillShapeTitle();

    $(".plexi-type").on("click", function () {
        var parentContainer = $(this).closest("[data-tab]");
        parentContainer.find(".plexi-shape").removeClass("active");
        parentContainer.find(".plexi-shape svg").each(function () {
            $(this).find("[fill^='rgba']").attr("fill", "rgba(16,83,106,0.1)");
        });

        parentContainer.find(".plexi-type").removeClass("active");
        $(this).addClass("active");

        parentContainer.find(".circle-option").removeClass("circle-option-check");
        $(this).find(".circle-option").addClass("circle-option-check");
    });

    const actualBtn = document.getElementById('actual-btn');

    const fileChosen = document.getElementById('file-chosen');

    actualBtn?.addEventListener('change', function () {
        fileChosen.textContent = this.files[0].name
    });
});